import { Layout } from 'module/ui/components/atoms/layout';
import { PageLoading } from 'module/ui/components/atoms/loading';
// import {
//   ProductiveHeading03,
//   ProductiveHeading05,
// } from 'module/ui/components/styles';
// import { Avatar, List } from 'antd';
import { useGetAllProjectsQuery, useGetInitQuery } from 'queries/project';
// import styled from 'styled-components';

// const Header = styled.div`
//   ${ProductiveHeading03};
//   margin-bottom: 24px;
// `;
// const Title = styled.div`
//   ${ProductiveHeading05};
// `;

export const Home = () => {
  const { data: initData, isLoading: initLoading } = useGetInitQuery();
  const { data, isLoading } = useGetAllProjectsQuery();

  if (initLoading || isLoading) {
    return <PageLoading />;
  }

  if (!initData || !data) {
    return <></>;
  }

  return (
    <Layout>
      <Layout.Content>
        {/* <Header>{`Welcome ${initData?.userProfile.user.firstName}`}</Header> */}

        {/* <List
          header={<Title>{'Projects'}</Title>}
          bordered
          dataSource={data ?? []}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar src={item.customer.companyLogoUrl} />}
                title={item.projectName + 'v1'}
              />
            </List.Item>
          )}
        /> */}
      </Layout.Content>
    </Layout>
  );
};
